import React from 'react';
import Modal from 'components/modal';
import { useRecoilState, useRecoilValue } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import { toggleSspModels, OrderPayload, toggleConfirmModel, currentSelection, invalidMember, memberForm, costApiLoading } from 'pages/myidm/store';
// import DeleteIcon from '@mui/icons-material/Delete';
import deleteIcon from 'assets/images/delete_icon.svg';
import { Box, TableContainer, Table, TableBody, TableHead, CircularProgress } from '@mui/material';
import { Styles, StyledTableCell, StyledTableRow, ActionStyledTableRow } from 'pages/myidm/style';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';
import { PRIVILEGED } from 'pages/myidm/utils/constant';
import AddMemberSearch from './AddMemberSearch';
import SecondaryAccountDropdown from './SecondaryAccountDropdown';

const MembersListModal = () => {
    const [isModelOpen, setModelOpen] = useRecoilState(toggleSspModels);
    const [modal, setModal] = useRecoilState(toggleConfirmModel);
    const [current, setCurrent] = useRecoilState(currentSelection);
    const [, setInvalid] = useRecoilState(invalidMember);
    const [form, setForm] = useRecoilState(memberForm);
    const [isCancelLoading, setCancelLoading] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const isCostApiLoading = useRecoilValue(costApiLoading);
    const getmypamsafeApi = useMutation((payload) => axios.post(endPoints.myIdm.mypamsafe, payload));
    const [localMembers, setLocalMembers] = React.useState([]);
    const [secondaryOptions, setSecondaryOptions] = React.useState([]);

    const currentIndex = isModelOpen?.index;
    const isPrivileged = order?.multipleResourceGroups?.[currentIndex]?.activeDirectoryGroupType === PRIVILEGED;

    const secondaryAccountApi = useMutation((payload) => axios.post(endPoints.myIdm.secondaryAccountDetails, { membersGpid: [payload.gpid] }));

    // Initialize local members when modal opens
    React.useEffect(() => {
        if (isModelOpen?.isMemberlist && isModelOpen?.index !== undefined) {
            const existingMembers = order?.multipleResourceGroups?.[currentIndex]?.members || [];
            setLocalMembers(existingMembers);
        }
    }, [isModelOpen?.isMemberlist, isModelOpen?.index]);

    // Fetch secondary accounts whenever the selected member changes (privileged resource groups only)
    React.useEffect(() => {
        const gpid = form?.member?.gpid;
        if (isPrivileged && gpid) {
            secondaryAccountApi.mutate(
                { gpid },
                {
                    onSuccess: (data) => {
                        const details = data?.data?.secondaryAccountDetails?.[0]?.accountDetails || [];
                        const mappedOptions = details.map((d) => ({ label: d.secondaryAccountName, ...d }));
                        if (mappedOptions.length === 1) {
                            setSecondaryOptions([]);
                            setOrder((prev) => ({ ...prev, selectedSecondaryAccount: mappedOptions[0], hasSecondaryAccounts: true }));
                        } else if (mappedOptions.length > 1) {
                            setSecondaryOptions(mappedOptions);
                            setOrder((prev) => ({ ...prev, selectedSecondaryAccount: null, hasSecondaryAccounts: true }));
                        } else {
                            setSecondaryOptions([]);
                            setOrder((prev) => ({ ...prev, selectedSecondaryAccount: null, hasSecondaryAccounts: false }));
                        }
                    },
                    onError: () => {
                        setSecondaryOptions([]);
                        setOrder((prev) => ({ ...prev, selectedSecondaryAccount: null, hasSecondaryAccounts: false }));
                    },
                }
            );
        } else {
            setSecondaryOptions([]);
            setOrder((prev) => ({ ...prev, selectedSecondaryAccount: null, hasSecondaryAccounts: false }));
        }
    }, [form?.member?.gpid, isPrivileged]);

    const handleCloseModal = () => {
        setModelOpen({ ...isModelOpen, isMemberlist: false });
        setForm({
            ...form,
            member: null,
            selectedMember: null,
        });
        setOrder({ ...order, serviceAccount: null, selectedSecondaryAccount: null, hasSecondaryAccounts: false });
    };
    const handleDelete = () => {
        setLocalMembers(() => localMembers.filter((value) => value?.gpid !== current?.gpid));
        setCurrent(null);
        setModal({ ...modal, isOpen: false, message: '', action: false });
        if (localMembers?.length === 1) setInvalid(true);
    };

    const handleDeleteConfirm = (member) => {
        setCurrent(member);
        setModal({ ...modal, isOpen: true, message: `Are you sure you want to remove ${member?.name ? member?.name : member?.gpid} ?`, action: false });
    };

    React.useEffect(() => {
        if (modal?.action && current?.gpid) {
            handleDelete();
        }
    }, [modal.action]);

    React.useEffect(() => {
        if (getmypamsafeApi?.data?.data) {
            let result = [];
            const safeGpid = getmypamsafeApi?.data?.data?.safeDetails?.map((pamsafe) => pamsafe?.safeOwner);
            if (getmypamsafeApi?.data?.data?.safeDetails?.length > 0) {
                localMembers?.map((obj) => {
                    if (!safeGpid?.includes(obj?.gpid)) {
                        result?.push(obj?.gpid);
                    }
                    return '';
                });
            } else {
                result = localMembers?.map((mem) => mem?.gpid);
            }

            setOrder({ ...order, mypamsafeDetails: getmypamsafeApi?.data?.data?.safeDetails, nonSafeDetailsGpid: result });
            setModelOpen({ ...isModelOpen, isMemberlist: false });
        }
    }, [getmypamsafeApi?.isSuccess]);
    const handleSavingMembers = () => {
        if (currentIndex !== undefined) {
            const updatedGroups = [...(order?.multipleResourceGroups || [])];
            updatedGroups[currentIndex] = {
                ...updatedGroups[currentIndex],
                members: localMembers,
            };
            setOrder({ ...order, multipleResourceGroups: updatedGroups });
        } else {
            // Fallback for old behavior if no index is provided
            setOrder({ ...order, members: localMembers });
        }

        if (!isPrivileged) {
            setModelOpen({ ...isModelOpen, isMemberlist: false });
        }

        if (isPrivileged) {
            const gpidMembers = localMembers.filter((mem) => mem.name !== 'System Account').map((mem) => mem.gpid);
            getmypamsafeApi?.mutate({ membersGpid: gpidMembers });
        }
    };
    const handleCancelRequest = () => {
        setCancelLoading(true);
        setModelOpen({ ...isModelOpen, isMemberlist: false });
        setCancelLoading(false);
        setForm({
            ...form,
            member: null,
            selectedMember: null,
        });
    };
    return (
        <Modal title="Members List" handleClose={() => handleCloseModal()} open={isModelOpen?.isMemberlist} width="45%">
            <>
                <Box
                    sx={{ minWidth: (theme) => theme.spacing(60), width: 'auto', display: 'flex', height: '100%', flexDirection: 'column', overflow: 'hidden' }}
                >
                    <Box sx={{ overflow: 'auto', pt: (theme) => theme.spacing(2), height: '100%' }}>
                        <AddMemberSearch localMembers={localMembers} setLocalMembers={setLocalMembers} secondaryAccountApi={secondaryAccountApi} />
                        {isPrivileged && <SecondaryAccountDropdown options={secondaryOptions} isLoading={secondaryAccountApi.isLoading} />}
                        <Box>
                            <TableContainer sx={Styles?.AddMemberForm?.table.tableWrapper}>
                                <Table sx={{ ...Styles?.AddMemberForm?.table?.main, height: 'auto', borderSpacing: 0 }} size="small" stickyHeader>
                                    {localMembers?.length > 0 && (
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>GPID</StyledTableCell>
                                                <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Full Name</StyledTableCell>
                                                <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Email ID</StyledTableCell>
                                                {isPrivileged && (
                                                    <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Secondary Account</StyledTableCell>
                                                )}
                                                <StyledTableCell aria-label="action" sx={{ backgroundColor: '#E5F5FC !important' }}>
                                                    &nbsp;
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                    )}
                                    <TableBody>
                                        <ActionStyledTableRow>
                                            {localMembers?.length < 1 && <StyledTableCell>No members selected.</StyledTableCell>}
                                        </ActionStyledTableRow>

                                        {localMembers?.length > 0 ? (
                                            <>
                                                {!localMembers.loading &&
                                                    localMembers?.map((member) => (
                                                        <StyledTableRow className="animate-opacity" key={member?.gpid}>
                                                            <StyledTableCell>{member?.gpid || ''}</StyledTableCell>
                                                            <StyledTableCell>{member?.name || '-'}</StyledTableCell>
                                                            <StyledTableCell>{member?.email || '-'}</StyledTableCell>
                                                            {isPrivileged && (
                                                                <StyledTableCell>{member?.secondaryAccount?.secondaryAccountName || '-'}</StyledTableCell>
                                                            )}

                                                            <StyledTableCell onClick={() => handleDeleteConfirm(member)}>
                                                                {/* <DeleteIcon
                                                                    sx={Styles?.AddMemberForm?.removeBtn}
                                                                    color="error"
                                                                    onClick={() => handleDeleteConfirm(member)}
                                                                    data-testid="remove-btn"
                                                                    className="animate-opacity"
                                                                /> */}
                                                                <img style={Styles?.AddMemberForm?.removeBtn} src={deleteIcon} alt="deleteIcon" />
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                            </>
                                        ) : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (theme) => theme.spacing(2) }}>
                        {(localMembers?.length > 0 || order?.multipleResourceGroups?.[isModelOpen?.index]?.members?.length > 0) && (
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                                <Btn
                                    variant="contained"
                                    color="cmpPrimary"
                                    onClick={() => handleSavingMembers()}
                                    /*   sx={{
                                        width: (theme) => theme.spacing(15.75),
                                        height: (theme) => theme.spacing(4.375),
                                        marginBottom: 1,
                                        marginRight: 1,
                                    }} */
                                    sx={{ ...style.modalSaveButton, marginRight: '8px', marginBottom: '8px', width: '130px' }}
                                    disabled={
                                        getmypamsafeApi?.isLoading ||
                                        isCostApiLoading ||
                                        (isPrivileged && order?.hasSecondaryAccounts && !order?.selectedSecondaryAccount)
                                    }
                                >
                                    {getmypamsafeApi?.isLoading ? <CircularProgress color="inherit" size={16} /> : 'Save'}
                                </Btn>
                                <Btn
                                    onClick={() => handleCancelRequest()}
                                    // color="cmpPrimary"
                                    variant="outlined"
                                    /*   sx={{
                                        width: (theme) => theme.spacing(15.75),
                                        height: (theme) => theme.spacing(4.375),
                                        marginBottom: 1,
                                    }} */
                                    sx={{ ...style.modalCancelButton, marginRight: '8px', marginBottom: '8px', width: '130px' }}
                                    data-testId="cancel-btn"
                                >
                                    {isCancelLoading ? <CircularProgress color="inherit" size={16} /> : 'Cancel'}
                                </Btn>
                            </Box>
                        )}
                    </Box>
                </Box>
            </>
        </Modal>
    );
};

export default React.memo(MembersListModal);
